import { commonLinks, webRoutes } from '@local/utils'

import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import useIsPreviousInternalRouting from '@web/hooks/useIsInternalRouting'
import { useNavigation } from '@web/hooks/useNavigation'
import usePageInfo from '@web/hooks/usePageInfo'
import { DEFAULT_USER_NICKNAME } from '@web/libs/constants'
import { Header } from '@web/ui/components/Header/Simple'

const ReviewHeader = () => {
  const { isFromMapsApp } = useGlobalStaticStateContext()
  const isPreviousInternalRouting = useIsPreviousInternalRouting()
  const { isMyPage, pageOwner } = usePageInfo()
  const navigation = useNavigation()

  const showMyReview = isMyPage && (isFromMapsApp || isPreviousInternalRouting)
  const showMyPlaceLogo = !showMyReview && !isFromMapsApp
  const showReviewWriteButton = !isMyPage && !isFromMapsApp

  const handleClickClose = () => navigation.back()
  const handleClickBack = () => navigation.back()
  const handleClickReviewWrite = () => {
    navigation.push({ url: webRoutes.HOME_MY_REVIEW })
  }
  const handleClickMyplace = () => navigation.push({ url: webRoutes.HOME })
  const handleClickNaver = () => navigation.push({ url: commonLinks.NAVER })

  return (
    <Header
      showProfileOnScroll
      title={showMyReview ? '내 리뷰' : null}
      showBackButton={false}
      showMyPlaceLogo={showMyPlaceLogo}
      showCloseButton={!showReviewWriteButton}
      showReviewWriteButton={showReviewWriteButton}
      onCloseClick={handleClickClose}
      onPrevClick={handleClickBack}
      onReviewWriteClick={handleClickReviewWrite}
      onMyplaceClick={handleClickMyplace}
      onNaverClick={handleClickNaver}
      profileImageUrl={pageOwner?.profile?.imageUrl || undefined}
      borderImageUrl={pageOwner?.profile?.border?.imageUrl || undefined}
      nickname={pageOwner?.profile?.nickname || DEFAULT_USER_NICKNAME}
    />
  )
}

export default ReviewHeader
